import PropTypes from 'prop-types';
import './ScanCardActions.scss';
import VerticalEllipsisIcon from './VerticalEllipsisIcon';

/**
 * ScanCardActions component - displays action buttons for a scan card
 * @param {Function} onMenuClick - Callback when menu is clicked
 * @param {Object} scan - The scan object
 * @returns React component that renders the actions menu
 */
const ScanCardActions = ({ onMenuClick, scan }) => {
  return (
    <div className="scan-card-actions" onClick={() => onMenuClick?.(scan)}>
      <VerticalEllipsisIcon />
    </div>
  );
};

ScanCardActions.propTypes = {
  onMenuClick: PropTypes.func,
  scan: PropTypes.object
};

export default ScanCardActions;
